export type WritingSection = "Section A" | "Section B";

export type WritingTaskV2 = {
  id: string;
  section: WritingSection;
  title?: string;
  prompt: string;
  userText: string;
  wordCount: number;
  minimumWordsRequired: number;
  meetsMinimumWordCount: boolean;
};

export type WritingCorrectionTypeV2 = "linguistic_feedback";

export type WritingErrorCategoryV2 =
  | "Gramática"
  | "Preposição"
  | "Conjugação"
  | "Concordância"
  | "Ortografia"
  | "Pontuação"
  | "Vocabulário"
  | "Sintaxe"
  | "Naturalidade"
  | "Conectores"
  | "Pronomes"
  | "Outro";

export type WritingErrorSeverityV2 = "low" | "medium" | "high";

export type WritingErrorV2 = {
  id: string;
  section: WritingSection;
  category: WritingErrorCategoryV2;
  severity: WritingErrorSeverityV2;
  original: string;
  corrected: string;
  contextSentence: string;
  explanation: string;
  flashcardSuggestion?: {
    front: string;
    back: string;
  };
};

export type WritingCorrectionResultV2 = {
  correctionType: WritingCorrectionTypeV2;
  isOfficialEvaluation: false;
  section: WritingSection;
  wordCount: number;
  minimumWordsRequired: number;
  meetsMinimumWordCount: boolean;
  generalFeedback: string;
  mainFocusAreas: WritingErrorCategoryV2[];
  errors: WritingErrorV2[];
  correctedVersion?: string;
  studySuggestions: string[];
  source: "gemini" | "simulated" | "manual" | "none";
  correctedAt: string;
};

export const WRITING_MIN_WORDS = {
  sectionA: 80,
  sectionB: 200,
};

export function countWords(text: string): number {
  return String(text || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
}

export function getMinimumWordsForSection(section: WritingSection): number {
  return section === "Section A" ? WRITING_MIN_WORDS.sectionA : WRITING_MIN_WORDS.sectionB;
}

export function buildWritingTaskV2(params: {
  id: string;
  section: WritingSection;
  title?: string;
  prompt: string;
  userText: string;
}): WritingTaskV2 {
  const wordCount = countWords(params.userText);
  const minimumWordsRequired = getMinimumWordsForSection(params.section);

  return {
    id: params.id,
    section: params.section,
    title: params.title,
    prompt: params.prompt,
    userText: params.userText,
    wordCount,
    minimumWordsRequired,
    meetsMinimumWordCount: wordCount >= minimumWordsRequired,
  };
}
